import { Fragment } from 'react';

import { Typography, TypographyProps } from '@material-ui/core';

import { tokenizeTextWithMentions } from '../../utils/mentions';
import { MentionChip } from '../MentionChip';

export interface TypographyWithMentionsProps extends TypographyProps {
  text: string;
}

export const TypographyWithMentions = ({
  text,
  ...props
}: TypographyWithMentionsProps) => {
  const tokens = tokenizeTextWithMentions(text);

  return (
    <Typography {...props}>
      {tokens.map((token, index) => (
        <Fragment key={index}>
          {typeof token === 'string' ? token : <MentionChip {...token} />}
        </Fragment>
      ))}
    </Typography>
  );
};
